module.exports = __webpack_public_path__ + "img/image-15.2b3ccb78.jpg";